import {
    IAudioNoteDetailsSource,
} from '../interfaces';

interface IResolveAudioNoteDetailsSourceArgs {
    slate: IAudioNoteDetailsSource,
    mediaItem?: IAudioNoteDetailsSource | null,
}

const resolveText = (
    primary?: string,
    fallback?: string,
): string => {
    if (typeof primary === 'string') {
        return primary;
    }

    return fallback || '';
};

/**
 * Resolves the editable/displayed audio-note details.
 * Firestore media items are the canonical source once loaded, while embedded
 * Slate details remain the fallback for unloaded or legacy notes.
 */
const resolveAudioNoteDetailsSource = ({
    slate,
    mediaItem,
}: IResolveAudioNoteDetailsSourceArgs): IAudioNoteDetailsSource => ({
    title: resolveText(mediaItem?.title, slate.title),
    description: resolveText(mediaItem?.description, slate.description),
});

export default resolveAudioNoteDetailsSource;
